export const SEGMENT_SIDE_OFFSET = 40
export const NODE_X_GAP = 80
export const NODE_Y_GAP = 60
export const NODE_WIDTH = 200
export const NODE_HEIGHT = 60
